module.exports = __webpack_public_path__ + "media/companies/CNP-e4251b3b.png";